// source: pbtypes/vehicle/skills/actions/set_subject_follower_settings/set_subject_follower_settings.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_subject_follower_subject_follower_settings_pb = require('../../../../../pbtypes/gen/subject_follower/subject_follower_settings_pb.js');
goog.object.extend(proto, pbtypes_gen_subject_follower_subject_follower_settings_pb);
var pbtypes_vehicle_infrastructure_flight_deck_settings_pb = require('../../../../../pbtypes/vehicle/infrastructure/flight_deck/settings_pb.js');
goog.object.extend(proto, pbtypes_vehicle_infrastructure_flight_deck_settings_pb);
goog.exportSymbol('proto.skills.SetSubjectFollowerSettingsActionArgs', null, global);
goog.exportSymbol('proto.skills.SetSubjectFollowerSettingsActionStateData', null, global);
goog.exportSymbol('proto.skills.SetSubjectFollowerSettingsResultData', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.SetSubjectFollowerSettingsActionArgs = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.SetSubjectFollowerSettingsActionArgs, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.SetSubjectFollowerSettingsActionArgs.displayName = 'proto.skills.SetSubjectFollowerSettingsActionArgs';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.SetSubjectFollowerSettingsResultData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.SetSubjectFollowerSettingsResultData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.SetSubjectFollowerSettingsResultData.displayName = 'proto.skills.SetSubjectFollowerSettingsResultData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.SetSubjectFollowerSettingsActionStateData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.SetSubjectFollowerSettingsActionStateData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.SetSubjectFollowerSettingsActionStateData.displayName = 'proto.skills.SetSubjectFollowerSettingsActionStateData';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.SetSubjectFollowerSettingsActionArgs.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.SetSubjectFollowerSettingsActionArgs.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.SetSubjectFollowerSettingsActionArgs} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.SetSubjectFollowerSettingsActionArgs.toObject = function(includeInstance, msg) {
  var f, obj = {
settings: (f = msg.getSettings()) && pbtypes_gen_subject_follower_subject_follower_settings_pb.SubjectFollowerSettings.toObject(includeInstance, f),
settings2: (f = msg.getSettings2()) && pbtypes_vehicle_infrastructure_flight_deck_settings_pb.SubjectSettings.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.SetSubjectFollowerSettingsActionArgs}
 */
proto.skills.SetSubjectFollowerSettingsActionArgs.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.SetSubjectFollowerSettingsActionArgs;
  return proto.skills.SetSubjectFollowerSettingsActionArgs.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.SetSubjectFollowerSettingsActionArgs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.SetSubjectFollowerSettingsActionArgs}
 */
proto.skills.SetSubjectFollowerSettingsActionArgs.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_gen_subject_follower_subject_follower_settings_pb.SubjectFollowerSettings;
      reader.readMessage(value,pbtypes_gen_subject_follower_subject_follower_settings_pb.SubjectFollowerSettings.deserializeBinaryFromReader);
      msg.setSettings(value);
      break;
    case 3:
      var value = new pbtypes_vehicle_infrastructure_flight_deck_settings_pb.SubjectSettings;
      reader.readMessage(value,pbtypes_vehicle_infrastructure_flight_deck_settings_pb.SubjectSettings.deserializeBinaryFromReader);
      msg.setSettings2(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.SetSubjectFollowerSettingsActionArgs.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.SetSubjectFollowerSettingsActionArgs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.SetSubjectFollowerSettingsActionArgs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.SetSubjectFollowerSettingsActionArgs.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSettings();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      pbtypes_gen_subject_follower_subject_follower_settings_pb.SubjectFollowerSettings.serializeBinaryToWriter
    );
  }
  f = message.getSettings2();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      pbtypes_vehicle_infrastructure_flight_deck_settings_pb.SubjectSettings.serializeBinaryToWriter
    );
  }
};


/**
 * optional subject_follower.SubjectFollowerSettings settings = 1;
 * @return {?proto.subject_follower.SubjectFollowerSettings}
 */
proto.skills.SetSubjectFollowerSettingsActionArgs.prototype.getSettings = function() {
  return /** @type{?proto.subject_follower.SubjectFollowerSettings} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_subject_follower_subject_follower_settings_pb.SubjectFollowerSettings, 1));
};


/**
 * @param {?proto.subject_follower.SubjectFollowerSettings|undefined} value
 * @return {!proto.skills.SetSubjectFollowerSettingsActionArgs} returns this
*/
proto.skills.SetSubjectFollowerSettingsActionArgs.prototype.setSettings = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skills.SetSubjectFollowerSettingsActionArgs} returns this
 */
proto.skills.SetSubjectFollowerSettingsActionArgs.prototype.clearSettings = function() {
  return this.setSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skills.SetSubjectFollowerSettingsActionArgs.prototype.hasSettings = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional flight_deck.SubjectSettings settings2 = 3;
 * @return {?proto.flight_deck.SubjectSettings}
 */
proto.skills.SetSubjectFollowerSettingsActionArgs.prototype.getSettings2 = function() {
  return /** @type{?proto.flight_deck.SubjectSettings} */ (
    jspb.Message.getWrapperField(this, pbtypes_vehicle_infrastructure_flight_deck_settings_pb.SubjectSettings, 3));
};


/**
 * @param {?proto.flight_deck.SubjectSettings|undefined} value
 * @return {!proto.skills.SetSubjectFollowerSettingsActionArgs} returns this
*/
proto.skills.SetSubjectFollowerSettingsActionArgs.prototype.setSettings2 = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skills.SetSubjectFollowerSettingsActionArgs} returns this
 */
proto.skills.SetSubjectFollowerSettingsActionArgs.prototype.clearSettings2 = function() {
  return this.setSettings2(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skills.SetSubjectFollowerSettingsActionArgs.prototype.hasSettings2 = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.SetSubjectFollowerSettingsResultData.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.SetSubjectFollowerSettingsResultData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.SetSubjectFollowerSettingsResultData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.SetSubjectFollowerSettingsResultData.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.SetSubjectFollowerSettingsResultData}
 */
proto.skills.SetSubjectFollowerSettingsResultData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.SetSubjectFollowerSettingsResultData;
  return proto.skills.SetSubjectFollowerSettingsResultData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.SetSubjectFollowerSettingsResultData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.SetSubjectFollowerSettingsResultData}
 */
proto.skills.SetSubjectFollowerSettingsResultData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.SetSubjectFollowerSettingsResultData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.SetSubjectFollowerSettingsResultData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.SetSubjectFollowerSettingsResultData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.SetSubjectFollowerSettingsResultData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.SetSubjectFollowerSettingsActionStateData.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.SetSubjectFollowerSettingsActionStateData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.SetSubjectFollowerSettingsActionStateData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.SetSubjectFollowerSettingsActionStateData.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.SetSubjectFollowerSettingsActionStateData}
 */
proto.skills.SetSubjectFollowerSettingsActionStateData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.SetSubjectFollowerSettingsActionStateData;
  return proto.skills.SetSubjectFollowerSettingsActionStateData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.SetSubjectFollowerSettingsActionStateData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.SetSubjectFollowerSettingsActionStateData}
 */
proto.skills.SetSubjectFollowerSettingsActionStateData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.SetSubjectFollowerSettingsActionStateData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.SetSubjectFollowerSettingsActionStateData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.SetSubjectFollowerSettingsActionStateData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.SetSubjectFollowerSettingsActionStateData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.skills);
